import { trans } from "i18n";

export const icons = {
	"accounting":           "fa-calculator-simple",
	"coaching":             "fa-user-group-simple",
	"consulting":           "fa-user-tie-hair",
	"counseling":           "fa-people-pants",
	"design":               "fa-swatchbook",
	"events":               "fa-ticket",
	"finance":              "fa-money-bill-1",
	"home-improvement":     "fa-hammer-brush",
	"it":                   "fa-laptop-mobile",
	"insurance":            "fa-car-burst",
	"law":                  "fa-book-section",
	"marketing":            "fa-megaphone",
	"medical":              "fa-kit-medical",
	"mental":               "fa-hand-holding-seedling",
	"municipal-services":   "fa-city",
	"operations":           "fa-user-headset",
	"personal-wellness":    "fa-spa",
	"photography":          "fa-camera",
	"real-estate":          "fa-sign-hanging",
	"religion":             "fa-hands-praying",
	"retail":               "fa-bag-shopping",
	"software-development": "fa-file-code",
	"therapy":              "fa-person-seat-reclined",
	"travel":               "fa-plane",
	"tutoring":             "fa-graduation-cap",
	"veterinary":           "fa-shield-dog",
	"writing":              "fa-typewriter",
	"other":                "fa-icons",

	// Categories
	"coaching/adhd":                              "fa-person-rays",
	"coaching/anxiety":                           "fa-face-anxious-sweat",
	"coaching/autism":                            "fa-puzzle",
	"coaching/burnout":                           "fa-bed",
	"coaching/business":                          "fa-building",
	"coaching/cancer":                            "fa-star-of-life",
	"coaching/career":                            "fa-file-user",
	"coaching/change-management":                 "fa-diamond-turn-right",
	"coaching/communication":                     "fa-microphone",
	"coaching/confidence":                        "fa-face-smile",
	"coaching/conflict":                          "fa-hand-peace",
	"coaching/corporate-training":                "fa-building-memo",
	"coaching/creativity":                        "fa-palette",
	"coaching/dating":                            "fa-heart",
	"coaching/depression":                        "fa-face-dotted",
	"coaching/diversity-and-inclusion":           "fa-heart-half-stroke",
	"coaching/divorce":                           "fa-people-pulling",
	"coaching/executive":                         "fa-user-tie",
	"coaching/family":                            "fa-people-roof",
	"coaching/financial":                         "fa-display-chart-up-circle-dollar",
	"coaching/grief":                             "fa-heart-crack",
	"coaching/health":                            "fa-heart-pulse",
	"coaching/holistic":                          "fa-flower-tulip",
	"coaching/innovation":                        "fa-lightbulb-on",
	"coaching/interview":                         "fa-user-group-simple",
	"coaching/investment":                        "fa-money-bill",
	"coaching/leadership":                        "fa-person-chalkboard",
	"coaching/lgbtqia":                           "fa-rainbow",
	"coaching/life":                              "fa-seedling",
	"coaching/menopause":                         "fa-monitor-waveform",
	"coaching/mental-health":                     "fa-hand-holding-seedling",
	"coaching/mid-life-crisis":                   "fa-face-clouds",
	"coaching/mindset":                           "fa-face-thinking",
	"coaching/motivational":                      "fa-battery-bolt",
	"coaching/negotiation":                       "fa-arrows-to-line",
	"coaching/nlp":                               "fa-head-side",
	"coaching/nutrition":                         "fa-carrot",
	"coaching/other":                             "fa-user-group-simple",
	"coaching/parenting":                         "fa-family",
	"coaching/performance":                       "fa-gauge-high",
	"coaching/productivity":                      "fa-chart-line-up",
	"coaching/public-speaking":                   "fa-microphone-stand",
	"coaching/recovery":                          "fa-hand-holding-droplet",
	"coaching/relationship":                      "fa-yin-yang",
	"coaching/resume-writing":                    "fa-pen-nib",
	"coaching/sales":                             "fa-messages-dollar",
	"coaching/team-building":                     "fa-people-group",
	"coaching/training":                          "fa-screen-users",
	"coaching/work-life":                         "fa-olive-branch",

	"consulting/business":                        "fa-briefcase",
	"consulting/construction":                    "fa-user-helmet-safety",
	"consulting/other":                           "fa-user-tie-hair",
	"consulting/strategy":                        "fa-bullseye",

	"counseling/academic":                        "fa-graduation-cap",
	"counseling/addiction":                       "fa-hand-holding-droplet",
	"counseling/alcohol-and-drug-abuse":          "fa-hand-holding-seedling",
	"counseling/anger-management":                "fa-face-swear",
	"counseling/behavioral":                      "fa-comments",
	"counseling/career":                          "fa-file-user",
	"counseling/career-development":              "fa-bullseye-arrow",
	"counseling/certified-couples":               "fa-people",
	"counseling/chemical-dependency":             "fa-cannabis",
	"counseling/child":                           "fa-child-reaching",
	"counseling/child-abuse":                     "fa-shield-xmark",
	"counseling/depression":                      "fa-face-dotted",
	"counseling/domestic-violence":               "fa-house-person-leave",
	"counseling/eating-disorder":                 "fa-fork-knife",
	"counseling/educational":                     "fa-building-columns",
	"counseling/elementary-school":               "fa-school",
	"counseling/family":                          "fa-family",
	"counseling/forensic":                        "fa-scale-balanced",
	"counseling/genetic":                         "fa-dna",
	"counseling/grief":                           "fa-heart-crack",
	"counseling/guidance":                        "fa-compass",
	"counseling/health":                          "fa-wave-pulse",
	"counseling/high-school-career":              "fa-chalkboard-user",
	"counseling/holistic-health":                 "fa-flower-tulip",
	"counseling/juvenile":                        "fa-child-dress",
	"counseling/juvenile-justice":                "fa-book-section",
	"counseling/marriage":                        "fa-rings-wedding",
	"counseling/mental-health":                   "fa-bag-seedling",
	"counseling/military":                        "fa-person-military-pointing",
	"counseling/nutrition":                       "fa-carrot",
	"counseling/other":                           "fa-people-pants",
	"counseling/prison":                          "fa-building-shield",
	"counseling/rehabilitation":                  "fa-arrow-progress",
	"counseling/relationship":                    "fa-yin-yang",
	"counseling/sports":                          "fa-flag-pennant",
	"counseling/trauma":                          "fa-face-anxious-sweat",
	"counseling/veterans":                        "fa-person-military-to-person",
	"counseling/vocational":                      "fa-universal-access",
	"counseling/wellness":                        "fa-spa",
	"counseling/youth":                           "fa-user-hair-long",

	"medical/family-medicine":                    "fa-users-medical",
	"medical/other":                              "fa-kit-medical",

	"mental/other":                               "fa-head-side-medical",

	"personal-wellness/conditioning-coach":       "fa-person-running-fast",
	"personal-wellness/fitness-instructor":       "fa-watch-fitness",
	"personal-wellness/other":                    "fa-spa",
	"personal-wellness/personal-trainer":         "fa-stopwatch",
	"personal-wellness/sleep-management-coach":   "fa-snooze",
	"personal-wellness/strength-coach":           "fa-dumbbell",
	"personal-wellness/weight-management":        "fa-scale-balanced",
	"personal-wellness/yoga-instructor":          "fa-yin-yang",

	"software-development/other":                 "fa-file-code",
	"software-development/web":                   "fa-globe-pointer",

	"therapy/couple":                             "fa-people",
	"therapy/other":                              "fa-users-medical",

	"tutoring/admissions-and-application":        "fa-passport",
	"tutoring/chemistry":                         "fa-flask-vial",
	"tutoring/chess":                             "fa-chess",
	"tutoring/danish":                            "fa-flag",
	"tutoring/elementary":                        "fa-school",
	"tutoring/english":                           "fa-flag",
	"tutoring/finnish":                           "fa-flag",
	"tutoring/french":                            "fa-flag",
	"tutoring/general-education":                 "fa-user-graduate",
	"tutoring/geography":                         "fa-globe-stand",
	"tutoring/german":                            "fa-flag",
	"tutoring/history":                           "fa-landmark-magnifying-glass",
	"tutoring/homework":                          "fa-house-user",
	"tutoring/italian":                           "fa-flag",
	"tutoring/language-and-esl":                  "fa-language",
	"tutoring/learning-disability":               "fa-chalkboard-user",
	"tutoring/mathematics":                       "fa-calculator-simple",
	"tutoring/norwegian":                         "fa-flag",
	"tutoring/other":                             "fa-graduation-cap",
	"tutoring/physics":                           "fa-atom-simple",
	"tutoring/polish":                            "fa-flag",
	"tutoring/portuguese":                        "fa-flag",
	"tutoring/pre-k":                             "fa-font-case",
	"tutoring/religious":                         "fa-hands-praying",
	"tutoring/spanish":                           "fa-flag",
	"tutoring/subject":                           "fa-book",
	"tutoring/swedish":                           "fa-flag",
	"tutoring/tech-and-coding":                   "fa-square-code",
	"tutoring/test-prep":                         "fa-file-certificate",

	"veterinary/cat":                             "fa-cat",
	"veterinary/companion-animal":                "fa-paw",
	"veterinary/dog":                             "fa-dog",
	"veterinary/livestock-food-and-large-animal": "fa-cow",
	"veterinary/other":                           "fa-shield-dog"
};

export const meta = {
	"coaching": {
		position: trans.gettext("Coach"),
		intro:    trans.gettext("Find and book an appointment with one of our top coaches to achieve your goals."),
		find:     trans.gettext("Find experienced coaches in the right coaching discipline to help you achieve your goals."),
		book:     trans.gettext("Easily and securely schedule 1:1 sessions with the perfect coach at a time that suits you."),
		meet:     trans.gettext("You'll meet on the Vixly secure video service (in-browser) or at the location of the coach.")
	},
	"coaching/adhd": {
		position: trans.gettext("ADHD Coach"),
		intro:    trans.gettext("Find and book an appointment with an ADHD coach today."),
		find:     trans.gettext("Find the right ADHD coach to help you thrive with ADHD personally and professionally."),
		book:     trans.gettext("Easily and securely schedule 1:1 sessions with an ADHD coach at a time that suits you."),
		meet:     trans.gettext("You'll meet on the Vixly video service (in-browser) or at the location of the ADHD coach.")
	},
	"coaching/anxiety": {
		position: trans.gettext("Anxiety Coach"),
		intro:    trans.gettext("Find and schedule time with an anxiety coach today."),
		find:     trans.gettext("Discover the perfect anxiety coach to help you cope with anxiety and build resilience."),
		book:     trans.gettext("Schedule secure, 1:1 sessions with an anxiety coach at a time that fits your schedule."),
		meet:     trans.gettext("Meet through Vixly's easy in-browser video service or at the office of your anxiety coach.")
	},
	"coaching/autism": {
		position: trans.gettext("Autism Coach"),
		intro:    trans.gettext("Find and book an appointment with an autism coach today."),
		find:     trans.gettext("Find an autism coach who understands your unique needs and helps you overcome challenges."),
		book:     trans.gettext("Easily book one-on-one sessions with an autism coach whenever it suits your availability."),
		meet:     trans.gettext("Connect via Vixly's online video platform or meet at your autism coach's location.")
	},
	"coaching/burnout": {
		position: trans.gettext("Burnout Coach"),
		intro:    trans.gettext("Find and book an appointment with a burnout coach today."),
		find:     trans.gettext("Find a burnout coach to support you in regaining energy and a healthier work-life balance."),
		book:     trans.gettext("Book one-on-one burnout coaching sessions easily and securely through Vixly."),
		meet:     trans.gettext("Meet your burnout coach on Vixly's video service or in person at the his/her office.")
	},
	"coaching/business": {
		position: trans.gettext("Business Coach"),
		intro:    trans.gettext("Find and schedule an appointment with a business coach today."),
		find:     trans.gettext("Find a business coach to guide you in growing your business and achieving professional goals."),
		book:     trans.gettext("Securely book 1:1 sessions with your business coach at a convenient time."),
		meet:     trans.gettext("Connect via Vixly's in-browser video service or meet your business coach in person.")
	},
	"coaching/cancer": {
		position: trans.gettext("Cancer Coach"),
		intro:    trans.gettext("Find and book an appointment with a cancer coach."),
		find:     trans.gettext("Discover a cancer coach who can provide guidance and support through your cancer journey."),
		book:     trans.gettext("Easily and securely schedule 1:1 sessions with a cancer coach at a time that suits you."),
		meet:     trans.gettext("You'll meet on the Vixly video service (in-browser) or at the location of the cancer coach.")
	},
	"coaching/career": {
		position: trans.gettext("Career Coach"),
		intro:    trans.gettext("Find and book a meeting with a career coach near you or online."),
		find:     trans.gettext("Choose a career coach to help you navigate career decisions and reach your professional goals."),
		book:     trans.gettext("Easily and securely schedule a 1:1 meeting with a career coach near you or online."),
		meet:     trans.gettext("Meet online through Vixly's video service or in person at your career coach's location."),
		splash: {
			ads: {
				ccd: {
					keyword:      "Career Coach Directory",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? Find an expert in the career coach directory to help you reach your goals.",
					featured:     "Career Coach Directory",
					benefitHead:  "Benefits of the career coach directory",
					benefitIntro: "A coach in the career coach directory can provide you with:",
					whyHead:      "Why using the Vixly career coach directory?",
					whyIntro:     "Connect with a top-tier independent coach in the career coach directory:"
				},
				ccnm: {
					keyword:      "Career Coach Near Me",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? A career coach near you can help you reach your goals.",
					featured:     "Featured Career Coaches Near Me",
					benefitHead:  "Benefits of career coaching",
					benefitIntro: "Career coaching can provide you with:",
					whyHead:      "Why using a career coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top-tier independent career coach near you:"
				},
				fcc: {
					keyword:      "Find Career Coach",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? Find a career coach on Vixly to help you reach your goals.",
					featured:     "Find Career Coach Today",
					benefitHead:  "Benefits of career coaching",
					benefitIntro: "Find a career coach that can provide you with:",
					whyHead:      "Why find a career coach on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top-tier independent career coach:"
				},
				fjc: {
					keyword:      "Find Job Coach",
					intro:        "Feeling stuck in your job? Ready to grow, switch paths or find fulfillment? Find a job coach on Vixly to help you reach your goals.",
					featured:     "Find Job Coach Today",
					benefitHead:  "Benefits of job coaching",
					benefitIntro: "Find a job coach that can provide you with:",
					whyHead:      "Why find a job coach on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top-tier independent job coach:"
				},
				fwc: {
					keyword:      "Find Work Coach",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? Find a work coach on Vixly to help you reach your goals.",
					featured:     "Find Work Coach Today",
					benefitHead:  "Benefits of work coaching",
					benefitIntro: "Find a work coach that can provide you with:",
					whyHead:      "Why find a work coach on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top-tier independent work coach:"
				},
				jcnm: {
					keyword:      "Job Coach Near Me",
					intro:        "Feeling stuck in your job? Ready to grow, switch paths or find fulfillment? A job coach near you can help you reach your goals.",
					featured:     "Featured Job Coaches Near Me",
					benefitHead:  "Benefits of job coaching",
					benefitIntro: "Job coaching can provide you with:",
					whyHead:      "Why using a job coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top-tier independent job coach near you:"
				},
				occ: {
					keyword:      "Online Career Coach",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? An online career coach on Vixly helps you reach your goals.",
					featured:     "Featured Online Career Coaches",
					benefitHead:  "Benefits of online career coaching",
					benefitIntro: "An online career coach can provide you with:",
					whyHead:      "Why using an online career coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top independent online career coach:"
				},
				ukcc: {
					keyword:      "UK Career Coaches",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? UK career coaches on Vixly helps you reach your goals.",
					featured:     "Featured UK Career Coaches",
					benefitHead:  "Benefits of career coaching",
					benefitIntro: "Career coaching can provide you with:",
					whyHead:      "Why using a career coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top independent UK career coach:"
				},
				wcnm: {
					keyword:      "Work Coach Near Me",
					intro:        "Feeling stuck in your career? Ready to grow, switch paths or find fulfillment? A work coach near you can help you reach your goals.",
					featured:     "Featured Work Coaches Near Me",
					benefitHead:  "Benefits of work coaching",
					benefitIntro: "Work coaching can provide you with:",
					whyHead:      "Why using a work coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top-tier independent work coach near you:"
				}
			},
			feedback: "My coach provided a very mind opening, insightful and perceptive discussion which I enjoyed, thank you. -Michelle",
			benefits: [
				"Clarity: Set clear goals and create an action plan.",
				"Confidence: Boost interview, networking, and negotiation skills.",
				"Growth: Tackle challenges and unlock your potential."
			],
			why: [
				"Expert Coaches: Trusted and vetted for quality.",
				"Flexible Booking: Schedule appointments that fit your schedule.",
				"All-in-One Platform: Book, pay and meet the coach on Vixly."
			]
		}
	},
	"coaching/change-management": {
		position: trans.gettext("Change Management Coach"),
		intro:    trans.gettext("Find and schedule an appointment with a change management coach today."),
		find:     trans.gettext("Find the right communication coach to improve your interpersonal skills and confidence."),
		book:     trans.gettext("Schedule a session with a communication coach at a time that works best for you."),
		meet:     trans.gettext("Meet virtually on Vixly's video platform or at the office of the communication coach.")
	},
	"coaching/communication": {
		position: trans.gettext("Communication Coach"),
		intro:    trans.gettext("Find and book an appointment with a communication coach today."),
		find:     trans.gettext("Discover the perfect communication coach to improve your communication skills."),
		book:     trans.gettext("Book secure, one-on-one communication coaching sessions at a convenient time."),
		meet:     trans.gettext("Meet on Vixly's video platform or at the location of the communication coach.")
	},
	"coaching/confidence": {
		position: trans.gettext("Confidence Coach"),
		intro:    trans.gettext("Find and book a call with a confidence coach."),
		find:     trans.gettext("Discover a confidence coach who can empower you to build self-assurance and confidence."),
		book:     trans.gettext("Schedule a call with your confidence coach securely and easily at a suitable time."),
		meet:     trans.gettext("Meet through Vixly's online video service or at the office of your confidence coach.")
	},
	"coaching/conflict": {
		position: trans.gettext("Conflict Coach"),
		intro:    trans.gettext("Find and book a call with a conflict coach today."),
		find:     trans.gettext("Find a conflict coach to assist in resolving disputes and improving relationships."),
		book:     trans.gettext("Book conflict coaching sessions easily and securely online at your convenience."),
		meet:     trans.gettext("Connect online via Vixly or meet your conflict coach in person, as you prefer.")
	},
	"coaching/corporate-training": {
		position: trans.gettext("Corporate Training Coach"),
		intro:    trans.gettext("Find and book a call with a corporate training coach today."),
		find:     trans.gettext("Find a corporate training coach to enhance team performance and drive results."),
		book:     trans.gettext("Schedule a call or meeting with a corporate training coach at your convenience."),
		meet:     trans.gettext("Meet on Vixly's secure video service or at the office of the corporate training coach.")
	},
	"coaching/creativity": {
		position: trans.gettext("Creativity Coach"),
		intro:    trans.gettext("Find and book an appointment with a creativity coach now."),
		find:     trans.gettext("Discover a creativity coach to unlock your potential and bring innovative ideas to life."),
		book:     trans.gettext("Easily book one-on-one creativity sessions with a coach whenever you're available."),
		meet:     trans.gettext("Meet on Vixly's video platform or in person at the office of your creativity coach.")
	},
	"coaching/dating": {
		position: trans.gettext("Dating Coach"),
		intro:    trans.gettext("Find and book a meeting with a dating coach today."),
		find:     trans.gettext("Choose a dating coach to guide you in building confidence and forming meaningful connections."),
		book:     trans.gettext("Easily and securely schedule 1:1 sessions with a dating coach at your preferred time."),
		meet:     trans.gettext("Meet online through Vixly's secure video service or at the location of your dating coach.")
	},
	"coaching/depression": {
		position: trans.gettext("Depression Coach"),
		intro:    trans.gettext("Find and book an appointment with a depression coach today."),
		find:     trans.gettext("Find a depression coach who provides empathetic support for managing mental health challenges."),
		book:     trans.gettext("Book sessions easily and securely with a depression coach at a time that suits you."),
		meet:     trans.gettext("Meet your depression coach on Vixly's secure video platform or in his/her office.")
	},
	"coaching/diversity-and-inclusion": {
		position: trans.gettext("Diversity and Inclusion Coach"),
		intro:    trans.gettext("Find and book a call with a diversity and inclusion coach."),
		find:     trans.gettext("Find a diversity and inclusion coach to foster a more inclusive workplace and mindset."),
		book:     trans.gettext("Schedule a 1:1 diversity and inclusion coaching session with ease and security."),
		meet:     trans.gettext("Meet on Vixly's secure video service or at the office of the diversity and inclusion coach.")
	},
	"coaching/divorce": {
		position: trans.gettext("Divorce Coach"),
		intro:    trans.gettext("Find and book a call with a divorce coach."),
		find:     trans.gettext("Discover a divorce coach to support you through the challenges of separation and rebuilding."),
		book:     trans.gettext("Easily and securely book a call with a divorce coach at a time that works for you."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the office of the dating coach.")
	},
	"coaching/executive": {
		position: trans.gettext("Executive Coach"),
		intro:    trans.gettext("Find and book a meeting with an executive coach today."),
		find:     trans.gettext("Find an executive coach to enhance your leadership skills and drive professional growth."),
		book:     trans.gettext("Easily schedule secure video sessions with an executive coach at your preferred time."),
		meet:     trans.gettext("Meet virtually on Vixly's secure video platform or at the office of the executive coach."),
		splash: {
			ads: {
				fecnm: {
					keyword:      "Find Executive Coach Near Me",
					intro:        "Lead with clarity and confidence. An executive coach on Vixly helps you tackle challenges, manage teams and develop as leader.",
					featured:     "Featured Executive Coaches",
					benefitHead:  "Benefits of executive coaching",
					benefitIntro: "Executive coaching can provide you with:",
					whyHead:      "Why using an executive coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top-tier independent executive coach:"
				}
			},
			feedback: "My coach provided a very mind opening, insightful and perceptive discussion which I enjoyed, thank you. -Michelle",
			benefits: [
				"Strategic Thinking: Sharpen decision-making and planning.",
				"Leadership Skills: Motivate and manage teams effectively.",
				"Resilience: Build strength to handle pressure and stay focused."
			],
			why: [
				"Expert Coaches: Trusted and vetted for quality.",
				"Flexible Booking: Schedule appointments that fit your schedule.",
				"All-in-One Platform: Book, pay and meet the coach on Vixly."
			]
		}
	},
	"coaching/family": {
		position: trans.gettext("Family Coach"),
		intro:    trans.gettext("Find and book a session with a family coach today."),
		find:     trans.gettext("Choose a family coach who can help you strengthen relationships and family dynamics."),
		book:     trans.gettext("Book a 1:1 or family session with a coach at a time that suits your schedule."),
		meet:     trans.gettext("Meet through Vixly's video service or at the location of your family coach.")
	},
	"coaching/financial": {
		position: trans.gettext("Financial Coach"),
		intro:    trans.gettext("Find and book a meeting with an financial coach today."),
		find:     trans.gettext("Find a financial coach to guide you toward better money management and financial goals."),
		book:     trans.gettext("Schedule a secure video session with a financial coach at a convenient time for you."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the location of the financial coach.")
	},
	"coaching/grief": {
		position: trans.gettext("Grief Coach"),
		intro:    trans.gettext("Find and book a consultation with a grief coach today."),
		find:     trans.gettext("Find a grief coach to help you process loss and find a path toward healing."),
		book:     trans.gettext("Book one-on-one sessions with a grief coach at a time that works for you."),
		meet:     trans.gettext("Meet your coach on Vixly's secure video service or at his/her office.")
	},
	"coaching/health": {
		position: trans.gettext("Health Coach"),
		intro:    trans.gettext("Find and book a consultation with a health coach today."),
		find:     trans.gettext("Discover a health coach to support your journey toward better well-being."),
		book:     trans.gettext("Schedule secure, one-on-one sessions with a health coach at a suitable time."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the office of your health coach.")
	},
	"coaching/holistic": {
		position: trans.gettext("Holistic Coach"),
		intro:    trans.gettext("Find and book a meeting with a holistic coach today."),
		find:     trans.gettext("Find a holistic coach to address your wellness needs in a balanced, integrated way."),
		book:     trans.gettext("Book secure video sessions with a holistic coach at a time that fits your schedule."),
		meet:     trans.gettext("Join your holistic coach on Vixly's secure video platform or at his/her location.")
	},
	"coaching/innovation": {
		position: trans.gettext("Innovation Coach"),
		intro:    trans.gettext("Find and book a meeting with an innovation coach today."),
		find:     trans.gettext("Connect with an innovation coach to inspire creative thinking and breakthrough ideas."),
		book:     trans.gettext("Securely book a meeting with an innovation coach that aligns with your availability."),
		meet:     trans.gettext("Meet securely on Vixly's video platform or at the location of your innovation coach.")
	},
	"coaching/interview": {
		position: trans.gettext("Interview Coach"),
		intro:    trans.gettext("Find and book a meeting with an interview coach today."),
		find:     trans.gettext("Choose an interview coach who can help you excel in job interviews and showcase your skills."),
		book:     trans.gettext("Book a 1:1 interview coaching session with the interview coach at a convenient time."),
		meet:     trans.gettext("Meet securely on Vixly's video service or at the location of the interview coach.")
	},
	"coaching/investment": {
		position: trans.gettext("Investment Coach"),
		intro:    trans.gettext("Find and book a meeting with an investment coach today."),
		find:     trans.gettext("Discover an investment coach who can guide your financial decisions for better outcomes."),
		book:     trans.gettext("Easily and securely schedule 1:1 sessions with an investment coach at a suitable time."),
		meet:     trans.gettext("Meet virtually on Vixly's secure video service or at the office of the investment coach.")
	},
	"coaching/leadership": {
		position: trans.gettext("Leadership Coach"),
		intro:    trans.gettext("Find and book a meeting with a leadership coach today."),
		find:     trans.gettext("Locate a leadership coach who will empower you to lead with confidence and clarity."),
		book:     trans.gettext("Schedule secure one-on-one sessions with a leadership coach when convenient."),
		meet:     trans.gettext("Meet virtually on Vixly's video platform or at the office of the leadership coach.")
	},
	"coaching/lgbtqia": {
		position: trans.gettext("LGBTQIA+ Coach"),
		intro:    trans.gettext("Find and book a call with an LGBTQIA+ coach today."),
		find:     trans.gettext("Find an LGBTQIA+ coach who provides inclusive, affirming guidance for personal growth."),
		book:     trans.gettext("Easily and securely book a 1:1 call with an LGBTQIA+ coach at a time that works for you."),
		meet:     trans.gettext("Meet virtually on Vixly's secure video service or at the office of the LGBTQIA+ coach.")
	},
	"coaching/life": {
		position: trans.gettext("Life Coach"),
		intro:    trans.gettext("Find and book an online life coach near me."),
		find:     trans.gettext("Find a coach in the life coaching directory who can help you achieve balance in life."),
		book:     trans.gettext("Securely book a session with a life coach at a time that aligns with your schedule."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the office of your life coach."),
		splash: {
			ads: {
				flc: {
					keyword:      "Find Life Coach",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find a life coach on Vixly to help you set goals, build habits and create the life you want.",
					featured:     "Find Life Coach Today",
					benefitHead:  "Benefits of life coaching",
					benefitIntro: "Find a life coach that can provide you with:",
					whyHead:      "Why find a life coach on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top-tier independent life coach:"
				},
				flcnm: {
					keyword:      "Find Life Coach Near Me",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find a life coach near you to help you set goals, build habits and create the life you want.",
					featured:     "Find Life Coach Near Me",
					benefitHead:  "Benefits of life coaching",
					benefitIntro: "Find a life coach that can provide you with:",
					whyHead:      "Why find a life coach on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top independent life coach near you:"
				},
				flm: {
					keyword:      "Find Life Mentor",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find a coach that can be your life mentor to help you set goals, build habits and create the life you want.",
					featured:     "Find Life Mentor Today",
					benefitHead:  "Benefits of life mentoring",
					benefitIntro: "Find a life mentor that can provide you with:",
					whyHead:      "Why find a life mentor on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top-tier independent life mentor:"
				},
				lcd: {
					keyword:      "Life Coach Directory",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find an expert in the life coach directory to help you set goals, build habits and create the life you want.",
					featured:     "Life Coach Directory",
					benefitHead:  "Benefits of the life coach directory",
					benefitIntro: "A coach in the life coach directory can provide you with:",
					whyHead:      "Why using the Vixly life coach directory?",
					whyIntro:     "Connect with a top-tier independent coach in the life coach directory:"
				},
				lmnm: {
					keyword:      "Life Mentor Near Me",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find a coach near you that can be your life mentor to help you set goals, build habits and create the life you want.",
					featured:     "Featured Life Mentors Near Me",
					benefitHead:  "Benefits of life mentoring",
					benefitIntro: "Find a life mentor that can provide you with:",
					whyHead:      "Why find a life mentor on Vixly?",
					whyIntro:     "We make it easy to find and connect with a top independent life mentor near you:"
				},
				uklc: {
					keyword:      "UK Life Coaches",
					intro:        "Looking for balance, purpose, and joy in your personal and professional life? Find a coach on Vixly to help you set goals, build habits and create the life you want.",
					featured:     "Featured Coaches",
					benefitHead:  "Benefits of life coaching",
					benefitIntro: "Life coaching can provide you with:",
					whyHead:      "Why using a life coach on Vixly?",
					whyIntro:     "We make it easy to connect with a top independent UK life coach:"
				}
			},
			feedback: "Thanks to my coach, I improved in key areas with her clear and thorough plan to reach my goals. I highly recommend her! -Lisa",
			benefits: [
				"Self-Discovery: Gain clarity on values, passions and purpose.",
				"Goal Setting: Turn dreams into goals and actionable plans.",
				"Resilience: Overcome challenges and build confidence."
			],
			why: [
				"Expert Coaches: Trusted and vetted for quality.",
				"Flexible Booking: Schedule appointments that fit your schedule.",
				"All-in-One Platform: Book, pay and meet the coach on Vixly."
			]
		}
	},
	"coaching/menopause": {
		position: trans.gettext("Menopause Coach"),
		intro:    trans.gettext("Find and book an online menopause coach today."),
		find:     trans.gettext("Choose a menopause coach to support you in managing symptoms and well-being during menopause."),
		book:     trans.gettext("Securely book a video session with a menopause coach at a time that works best for you."),
		meet:     trans.gettext("Meet on Vixly's online platform or at the location or office of the menopause coach.")
	},
	"coaching/mental-health": {
		position: trans.gettext("Mental Health Coach"),
		intro:    trans.gettext("Find and book a session with a mental health coach."),
		find:     trans.gettext("Find a mental health coach who offers guidance for emotional well-being and resilience."),
		book:     trans.gettext("Book private, one-on-one sessions with a mental health coach at your convenience."),
		meet:     trans.gettext("Meet on Vixly's video service or at the office of the mental health coach.")
	},
	"coaching/mid-life-crisis": {
		position: trans.gettext("Mid-life Crisis Coach"),
		intro:    trans.gettext("Find and book a consultation with a mid-life crisis coach."),
		find:     trans.gettext("Discover a mid-life crisis coach to help you navigate life changes and redefine goals."),
		book:     trans.gettext("Easily book secure, one-on-one consultation with a mid-life crisis coach."),
		meet:     trans.gettext("Meet on Vixly's secure video in-browser service or at the location of your coach.")
	},
	"coaching/mindset": {
		position: trans.gettext("Mindset Coach"),
		intro:    trans.gettext("Find and book an online mindset coach near me."),
		find:     trans.gettext("Discover a mindset coach who can help you develop positive and productive thinking."),
		book:     trans.gettext("Schedule sessions with a mindset coach securely and conveniently through Vixly."),
		meet:     trans.gettext("Meet on Vixly's online video service or meet in person, as arranged with your coach.")
	},
	"coaching/motivational": {
		position: trans.gettext("Motivational Coach"),
		intro:    trans.gettext("Find and book an online motivational coach near me."),
		find:     trans.gettext("Find a motivational coach who inspires you to achieve your personal and professional goals."),
		book:     trans.gettext("Book one-on-one sessions with a motivational coach at a time that fits your schedule."),
		meet:     trans.gettext("Meet online on Vixly's video service or in person, based on your preference.")
	},
	"coaching/negotiation": {
		position: trans.gettext("Negotiation Coach"),
		intro:    trans.gettext("Find and book a negotiation coach online."),
		find:     trans.gettext("Discover a negotiation coach to enhance your negotiation skills and strategy."),
		book:     trans.gettext("Schedule secure, personalized video sessions with a negotiation coach when convenient."),
		meet:     trans.gettext("Connect through Vixly's video service or meet at a location arranged with your coach.")
	},
	"coaching/nlp": {
		position: trans.gettext("NLP Coach"),
		intro:    trans.gettext("Find and book an appointment with an NLP coach today."),
		find:     trans.gettext("Find an NLP (Neuro-Linguistic Programming) coach to improve communication and mindset."),
		book:     trans.gettext("Easily book a meeting with an NLP coach at a time that works for you."),
		meet:     trans.gettext("Meet online on Vixly's video platform or at an agreed location with your coach.")
	},
	"coaching/nutrition": {
		position: trans.gettext("Nutrition Coach"),
		intro:    trans.gettext("Find and book an online nutrition coach near me."),
		find:     trans.gettext("Discover a nutrition coach to help you develop a healthier diet and lifestyle."),
		book:     trans.gettext("Securely book a session with a nutrition coach at a convenient time."),
		meet:     trans.gettext("Meet your nutrition coach on Vixly's video service or in person at the selected location.")
	},
	"coaching/other": {
		position: trans.gettext("Coach"),
		intro:    trans.gettext("Find and book an online coach near me."),
		find:     trans.gettext("Discover a coach who can help you achieve your goals and dreams."),
		book:     trans.gettext("Book a session with a coach at a time that aligns with your schedule."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the office of the coach.")
	},
	"coaching/parenting": {
		position: trans.gettext("Parenting Coach"),
		intro:    trans.gettext("Find and book a parenting coach near me or online."),
		find:     trans.gettext("Find a parenting coach to support you in fostering a positive family environment."),
		book:     trans.gettext("Book an appointment with a parenting coach at a time that suits you."),
		meet:     trans.gettext("Meet on Vixly's video service or in person, based on your preference.")
	},
	"coaching/performance": {
		position: trans.gettext("Performance Coach"),
		intro:    trans.gettext("Find and book an online performance coach near me."),
		find:     trans.gettext("Discover a performance coach to help you reach new levels of success."),
		book:     trans.gettext("Securely schedule sessions with a performance coach at your preferred time."),
		meet:     trans.gettext("Meet via Vixly's video platform or in person, as arranged with your coach.")
	},
	"coaching/productivity": {
		position: trans.gettext("Productivity Coach"),
		intro:    trans.gettext("Find and book an online productivity coach near me."),
		find:     trans.gettext("Find an online productivity coach to help you optimize your time and achieve your goals."),
		book:     trans.gettext("Easily book one-on-one sessions with a productivity coach at a suitable time."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or in person, as arranged with your coach.")
	},
	"coaching/public-speaking": {
		position: trans.gettext("Public Speaking Coach"),
		intro:    trans.gettext("Find and book a public speaking coach today."),
		find:     trans.gettext("Discover a public speaking coach to build your confidence and presentation skills."),
		book:     trans.gettext("Book secure, personalized public speaking video sessions at a time that fits you."),
		meet:     trans.gettext("Connect on Vixly's video service or at the office of the public speaking coach.")
	},
	"coaching/recovery": {
		position: trans.gettext("Recovery Coach"),
		intro:    trans.gettext("Find and book an online recovery coach near me."),
		find:     trans.gettext("Find a recovery coach to guide you through your journey toward wellness and resilience."),
		book:     trans.gettext("Securely book one-on-one sessions with a recovery coach at your convenience."),
		meet:     trans.gettext("Meet your recovery coach on Vixly's video platform or in person as you prefer.")
	},
	"coaching/relationship": {
		position: trans.gettext("Relationship Coach"),
		intro:    trans.gettext("Find and book an online relationship coach near me."),
		find:     trans.gettext("Find a relationship coach to help you enhance connections and improve communication."),
		book:     trans.gettext("Schedule sessions with a relationship coach at a time that works best for you."),
		meet:     trans.gettext("Meet on Vixly's video platform or at the office of the relationship coach.")
	},
	"coaching/resume-writing": {
		position: trans.gettext("Resume Writing Coach"),
		intro:    trans.gettext("Find and book an online resume writing coach."),
		find:     trans.gettext("Discover a resume writing coach to help you create a standout resume for job success."),
		book:     trans.gettext("Book one-on-one meeting with a resume writing coach at a time that fits your schedule."),
		meet:     trans.gettext("Meet on Vixly's secure video service or in person, depending on your preference.")
	},
	"coaching/sales": {
		position: trans.gettext("Sales Coach"),
		intro:    trans.gettext("Find and book an online sales coach near me."),
		find:     trans.gettext("Find a sales coach to improve skills, boost confidence, and close more deals."),
		book:     trans.gettext("Schedule an appointment with your sales coach securely and conveniently."),
		meet:     trans.gettext("Meet your sales coach on Vixly's secure video service or at his/her office.")
	},
	"coaching/team-building": {
		position: trans.gettext("Team Building Coach"),
		intro:    trans.gettext("Find and book a team building coach online."),
		find:     trans.gettext("Discover a team building coach to strengthen teamwork and collaboration skills."),
		book:     trans.gettext("Book a session with a team building coach at a time that aligns with your schedule."),
		meet:     trans.gettext("Meet on Vixly's secure video platform or at the office of the team building coach.")
	},
	"coaching/training": {
		position: trans.gettext("Training Coach"),
		intro:    trans.gettext("Find and book an online training coach near me."),
		find:     trans.gettext("Find a training coach who can help you develop new skills and reach your goals."),
		book:     trans.gettext("Book secure, one-on-one sessions with a training coach at a time that works for you."),
		meet:     trans.gettext("Meet your coach online on Vixly's video platform or at his/her location.")
	},
	"coaching/work-life": {
		position: trans.gettext("Work-Life Balance Coach"),
		intro:    trans.gettext("Find and book a work-life balance coach."),
		find:     trans.gettext("Discover a work-life balance coach to help you find harmony between work and personal life."),
		book:     trans.gettext("Easily and securely book sessions with a work-life balance coach at a convenient time."),
		meet:     trans.gettext("Meet on Vixly's video service or in person, based on your preference.")
	}
};

export const sortCats = (arr, key) => {
	return arr.sort((a, b) => {
		const astr = (a[key] === "other" ? 0xff : 0x00) + a.name;
		const bstr = (b[key] === "other" ? 0xff : 0x00) + b.name;

		if (astr < bstr)
			return -1;

		if (astr > bstr)
			return 1;

		return 0;
	});
};
